module.exports = __webpack_public_path__ + "img/inventory.02e6e021.png";